import React from 'react';
import { useMapStore } from '../../stores/mapStore';

export const LayerControls: React.FC = () => {
  const { selectedLayers, toggleLayer } = useMapStore();

  const layers = [
    {
      key: 'heatIslands' as const,
      label: 'Heat Islands',
      description: 'Urban heat island intensity zones',
      color: 'bg-orange-500',
    },
    {
      key: 'floodZones' as const,
      label: 'Flood Zones',
      description: 'FEMA flood risk areas',
      color: 'bg-blue-500',
    },
    {
      key: 'environmentalJustice' as const,
      label: 'Environmental Justice',
      description: 'EJ demographic overlay',
      color: 'bg-purple-500',
    },
    {
      key: 'communityTrees' as const,
      label: 'Community Trees',
      description: 'Existing tree locations',
      color: 'bg-green-500',
    },
        {
      key: 'hackensackBoundary' as const,
      label: 'Hackensack Boundary',
      description: 'Hackensack Boundary',
      color: 'bg-green-500',
    },
  ];

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium text-gray-700 mb-3">
        Data Layers
      </div>
      
      {layers.map((layer) => (
        <div key={layer.key} className="flex items-center space-x-3">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={selectedLayers[layer.key]}
              onChange={() => toggleLayer(layer.key)}
              className="sr-only"
            />
            <div className={`
              relative w-5 h-5 rounded border-2 transition-colors duration-200
              ${selectedLayers[layer.key] 
                ? 'bg-forest-600 border-forest-600' 
                : 'bg-white border-gray-300 hover:border-gray-400'
              }
            `}>
              {selectedLayers[layer.key] && (
                <svg
                  className="absolute inset-0 w-3 h-3 text-white m-auto"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </div>
            
            <div className="ml-3 flex-1">
              <div className="flex items-center space-x-2">
                <div className={`w-3 h-3 rounded-full ${layer.color}`}></div>
                <span className="text-sm font-medium text-gray-900">
                  {layer.label}
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                {layer.description}
              </p>
            </div>
          </label>
        </div>
      ))}
      
      <div className="pt-3 border-t border-gray-200">
        <div className="text-xs text-gray-500">
          Toggle layers to view different environmental data overlays on the map.
        </div>
      </div>
    </div>
  );
};
